import React from 'react';

export default function Header() {
    return (
        <div className="header">
            <h1 className="title">Radio Player</h1>
        </div>
    );
}
